import config from "../config";
import { getGeofences } from "../services/eventService";

// -------- CACHE PERSISTANT --------
let addressCache = {};
try {
  const stored = localStorage.getItem("vehicleAddressCache");
  if (stored) addressCache = JSON.parse(stored);
} catch (err) {
  console.warn("Impossible de lire le cache localStorage", err);
}

const Api_hash = config.api_hash;

export const fetchAddress = async (vehicle) => {
  if (!vehicle) return "";
  if (vehicle.address && vehicle.address !== "-") return vehicle.address;

  const lat = parseFloat(vehicle.lat);
  const lng = parseFloat(vehicle.lng);

  if (isNaN(lat) || isNaN(lng)) {
    console.warn("Coordonnées invalides pour ce véhicule:", vehicle);
    return "";
  }

  const key = `${lat}_${lng}`;
  if (addressCache[key]) return addressCache[key];

  // 🔹 Priorité Geofences
  try {
    const params = {
      lat: lat,
      lng: lng, // corrigé
      user_api_hash: Api_hash,
    };
    const { data } = await getGeofences(params);
    if (data && data.status === 1 && Array.isArray(data.zones) && data.zones.length > 0) {
      const zonesStr = data.zones.join(", "); // ex: "COBRA, Kinshasa"
      addressCache[key] = zonesStr;
      localStorage.setItem("vehicleAddressCache", JSON.stringify(addressCache));
      return zonesStr;
    }
  } catch (error) {
    console.error("Erreur getGeofences:", error);
  }

  // 🔹 Essayer OpenCage
/*   try {
    const res = await fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${lat}+${lng}&key=${API_KEY}&language=fr`
    );
    const data = await res.json();
    const addr = cleanAddress(data.results?.[0]?.formatted || "");
    if (addr) {
      addressCache[key] = addr;
      localStorage.setItem("vehicleAddressCache", JSON.stringify(addressCache));
      return addr;
    }
  } catch (err) {
    console.warn("OpenCage échoué, tentative avec Nominatim:", err);
  } */

  return "";
};
